import { YDatabase } from '@databases/collab/y-database';
import {
  CollabCardWidth,
  CollabCoverFieldType,
  CollabLayoutType,
  DatabaseViewJSON,
} from '@databases/model/views/view';
import { messages } from '@databases/views/messages';
import type { IntlShape } from 'react-intl-next';
import { v4 as uuidv4 } from 'uuid';

/**
 * This migration creates a default view for new databases.
 */
export const initialView = {
  version: 1725574719190, // timestamp of the migration when it's written
  apply(documentId: string, ydb: YDatabase, intl: IntlShape) {
    if (ydb.views.length > 0) {
      return;
    }

    const defaultViewId = uuidv4();
    const defaultView: DatabaseViewJSON = {
      name: `${intl.formatMessage(messages['view.default-view-name'])} 1`,
      calculations: {},
      cardWidth: CollabCardWidth.MEDIUM,
      coverField: { type: CollabCoverFieldType.Default },
      dateFieldId: undefined,
      showNumberedEntries: false,
      fields: undefined,
      filter: undefined,
      groupFieldId: undefined,
      layoutType: CollabLayoutType.TABLE,
      sort: undefined,
    };

    ydb.mutate(() => {
      ydb.addView(defaultViewId, defaultView);
      ydb.defaultViewId = defaultViewId;
    });
  },
};
